import axios from "axios";
const REACT_APP_API = process.env.REACT_APP_API_BASE_URL;

export const UpdatePhoneNumber = async ( userName, PhoneNumber ) => {
    try {
        const response = await axios.patch(
            `${REACT_APP_API}/api/Organization/CorporateUsers/UpdatePhoneNumber`,
            null,
            {
                params: {
                    User: userName,
                    PhoneNumber :PhoneNumber,
                },
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error in Update Phone Number:", error);
        throw error;
    }
};


export const UpdatePersonalEmailId = async ( User, EmailId ) => {
    console.log("User",User);
    console.log("EmailId",EmailId);
    try {
        const response = await axios.patch(
            `${REACT_APP_API}/api/Organization/CorporateUsers/UpdatePersonalEmailId`,
            null,
            {
                params: {
                    User: User,
                    Email: EmailId,
                },
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error in Update Email Id:", error);
        throw error;
    }
};


export const ChangeUserPassword = async (requestBody) => {
  console.log("ChangePasswordrequestBody", requestBody);
  try {
    const response = await axios.post(
      `${REACT_APP_API}/api/Account/ChangePassword`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("ChangePassword --> response:", response.data);
    return response.data;
  } catch (error) {
    console.error("ChangePassword --> error:", error.response?.data || error.message);
    throw error;
  }
};
